import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditExamTerm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [formData, setFormData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    term_name: '',
    sequence_no: '',
    is_active: true,
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (location.state) {
      setFormData(location.state);
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMessage((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    if (isSuperAdmin && !formData.vendor_id) {
      toast.error('Please select vendor');
      return false;
    }
    if ((isSuperAdmin || isAdmin || hasMultiBranch) && !formData.branch_id) {
      toast.error('Please select branch');
      return false;
    }
    if (!formData.term_name) {
      setErrorMessage({ term_name: 'Term name required' });
      return false;
    }
    if (!formData.sequence_no) {
      setErrorMessage({ sequence_no: 'Sequence required' });
      return false;
    }
    return true;
  };

  const saveData = async () => {
    if (!validate()) return;

    try {
      let res;
      if (formData.id > 0) {
        res = await apiService.put(
          `api/ExamMaster/UpdateExamTerm?id=${formData.id}`,
          formData
        );
      } else {
        res = await apiService.post(
          'api/ExamMaster/AddExamTerm',
          formData
        );
      }

      if (res.status) {
        toast.success(res.message);
        navigate('/list-exam-term');
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error('Something went wrong');
    }
  };

  const deleteData = async () => {
    if (!window.confirm('Delete this exam term?')) return;

    const res = await apiService.delete(
      `api/ExamMaster/DeleteExamTerm?id=${formData.id}`
    );

    if (res.status) {
      toast.success(res.message);
      navigate('/list-exam-term');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={formData}
        setSelectionData={setFormData}
        accessButton
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between'>
          <span>Exam Term Form</span>
          <div>
            <Button color='warning' onClick={() => navigate(-1)}>
              <i className='bi bi-arrow-left' />
            </Button>
            {formData.id > 0 && (
              <Button color='danger' className='ml-2' onClick={deleteData}>
                <i className='bi bi-trash' />
              </Button>
            )}
          </div>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Term Name</Label>
              <Input
                name='term_name'
                value={formData.term_name}
                onChange={onChangeHandle}
              />
              <FormText color='danger'>{errorMessage.term_name}</FormText>
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Sequence No</Label>
              <Input
                type='number'
                name='sequence_no'
                value={formData.sequence_no}
                onChange={onChangeHandle}
              />
              <FormText color='danger'>{errorMessage.sequence_no}</FormText>
            </FormGroup>
          </Row>

          <Button color='primary' className='float-end' onClick={saveData}>
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditExamTerm;
